export default [
  {
    path: '/b2bhub/operacoes/devolucao-saldo',
    name: 'devolucao-saldo',
    component: () => import('@/views/app/operacoes/devolucoes/saldoDevolucao.vue'),
    meta: {
      pageTitle: 'Saldo de Devolução',
      action: 'read',
      resource: 'DevolucaoSaldo',
    },
  },
];
